<template>
    <div class="mobile-line-container">
        <div class="mobile-line-item">
            <span class="mobile-label">
                Cotação:
            </span>
            <span class="mobile-value">
                {{ order.request.id }}
            </span>
        </div>

        <div class="mobile-line-item">
            <span class="mobile-label">
                Digitações:
            </span>
            <span class="mobile-value">
                {{ order.offers_count }}
            </span>
        </div>
        <div class="mobile-line-item">
            <span class="mobile-label">Pedidos:</span>
            <span class="mobile-value">{{ order.orders_count}}</span>
        </div>
        <div class="mobile-line-item">
            <span class="mobile-label">
                Data:
            </span>
            <span class="mobile-value">
                {{ order.request.created_at | formatDateOnly }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderMobileLine',
    props: {
        order: {
            type: Object,
            required: true
        }
    },
}
</script>

<style scoped>
    .mobile-line-container {
        display: none;
        padding: 15px;
        border-bottom: 1px solid #e5e5e5;
        background: #fff;
    }
    .mobile-line-item{
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .mobile-label{
        font-weight: bold;
        color: #605F5F;
    }.mobile-value {
  color: #605F5F;
}

@media only screen and (max-width: 800px) {
  .mobile-line-container {
    display: block;
  }
}
</style>

